import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Autoplay, Navigation} from 'swiper/modules';
import portfolioData from "../../../data/portfolio-data";

const PortfolioThree = () => {
    const slideControl = {
        spaceBetween: 25,
        centeredSlides: true,
        speed: 1000,
        loop: true,
        autoplay: {
            delay: 4000,
            reverseDirection: false,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: '.portfolio_next',
            prevEl: '.portfolio_prev',
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 1.5,
            },
            1025: {
                slidesPerView: 3,
            },
            1600: {
                slidesPerView: 3.7,
            },
        },
    };
    return (
        <div className="portfolio__three">
        </div>
    );
};

export default PortfolioThree;